import { CircularProgress as CircularProgress_ } from "@chakra-ui/react";
import { forwardRef } from "react";
export const CircularProgress = forwardRef(({ ...props }, ref) => {
    return <CircularProgress_ ref={ref} {...props}>{props?.children}</CircularProgress_>
});

import { CircularProgressLabel as CircularProgressLabel_ } from "@chakra-ui/react";
export const CircularProgressLabel = forwardRef(({ ...props }, ref) => {
    return <CircularProgressLabel_ ref={ref} {...props}>{props?.children}</CircularProgressLabel_>
});